module.exports = __webpack_public_path__ + "themes/mf/font/proximasoft-regular-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/font/proximasoft-regular-webfont.svg
// module id = 143
// module chunks = 3